import type { MessageView } from '@hilo/contracts';
import { REFERRAL_LABEL } from '../../lib/copy';
import { useCurrentUser } from '../../lib/session';
import { formatDayHeading, formatTime } from '../../lib/time';
import styles from './OriginPanel.module.css';

/** Solo enlaces https; cualquier otra URL se muestra como texto, nunca como enlace ni HTML. */
function safeHttpsUrl(value: string | null): string | null {
  if (!value) return null;
  try {
    const url = new URL(value);
    return url.protocol === 'https:' ? url.toString() : null;
  } catch {
    return null;
  }
}

/** Origen de publicación: cada mensaje conserva el suyo; se listan todos, del más reciente al más antiguo. */
export function OriginPanel({ messages }: { messages: MessageView[] }) {
  const user = useCurrentUser();
  const origins = messages.filter((message) => message.referral !== null).reverse();

  return (
    <section className={styles.block}>
      <h3 className={styles.title}>Origen</h3>
      {origins.length === 0 ? (
        <p className={styles.none}>Origen de publicación no disponible</p>
      ) : (
        <ul className={styles.list}>
          {origins.map((message) => {
            const referral = message.referral!;
            const href = safeHttpsUrl(referral.url);
            return (
              <li key={message.id} className={styles.item}>
                <span className={styles.kind}>{REFERRAL_LABEL[referral.kind]}</span>
                <span className={styles.name}>{referral.title ?? 'Sin título'}</span>
                <span className={styles.when}>
                  {formatDayHeading(message.receivedAt, user.timezone)} · {formatTime(message.receivedAt, user.timezone)}
                </span>
                {href && (
                  <a className={styles.link} href={href} target="_blank" rel="noopener noreferrer">Abrir {REFERRAL_LABEL[referral.kind].toLowerCase()}</a>
                )}
                {referral.externalId && <span className={styles.id}>ID {referral.externalId}</span>}
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}
